import { useState } from "react"
import done from "../../assets/img/done.svg"
import showMoreImg from "../../assets/img/show-more.svg"

import ico1 from "../../assets/img/ico-1.svg"
import ico2 from "../../assets/img/ico-2.svg"
import ico3 from "../../assets/img/ico-3.svg"
import ico4 from "../../assets/img/ico-4.svg"
import ico5 from "../../assets/img/ico-5.svg"
import ico6 from "../../assets/img/ico-6.svg"
import ico7 from "../../assets/img/ico-7.svg"
import ico8 from "../../assets/img/ico-8.svg"
import ico9 from "../../assets/img/ico-9.svg"
import ico10 from "../../assets/img/ico-10.svg"
import ico11 from "../../assets/img/ico-11.svg"

import "./styles.scss"

const ShortAdd = ({ lang }) => {
  const [showMore, setShowMore] = useState(false)

  // const roContent = () => {
  //   return (
  //     <div class="single-service services-container" >
  //       <div class="inner-data">
  //         <div class="service-detail">
  //           <div class="col-det">
  //             <p class="headf1" id="productss">Servicii Turbo Wheel</p>
  //             <div class="flex-detail">
  //               <div class="col-one">
  //                 <img src={ico1} alt="" />
  //                 <div>
  //                   <h2 class="col-head" >Reparație șasiu</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Diagnosticarea și repararea suspensiei
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Schimbarea amortizoarelor, tijei, 
  //                       bucșei (șarovaia, tiaga, soldatic)
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Repararea si reglarea 
  //                       casetei de direcție
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Verificarea și înlocuirea 
  //                       rulmenților roților
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //               <div class="col-one">
  //                 <img src={ico2} alt="" />
  //                 <div>
  //                   <h2 class="col-head">Diagnosticare computerizată</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Verificarea și citirea erorilor 
  //                       unităților electronice de control (ECU).
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Diagnosticarea motorului, transmisiei, 
  //                       ABS și a altor sisteme
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Analiza parametrilor a vehiculului 
  //                       în timp real
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Ștergerea erorilor și 
  //                       adaptarea după reparație
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Programarea si configurarea 
  //                       electronicii
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //               <div class="col-one">
  //                 <img src={ico3} alt="" />
  //                 <div>
  //                   <h2 class="col-head">Electrica auto</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Diagnosticarea și repararea cablajului auto
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Înlocuire generator și starter
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Configurarea și restaurarea 
  //                       dispozitivelor de iluminat
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Programarea si adaptarea 
  //                       unităților de control
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //             </div>
  //             {showMore && (
  //               <div class="flex-detail mapedCategories">
  //                 <div class="col-one">
  //                   <img src={ico4} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Uleiuri și lichide</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea uleiului de motor
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea uleiului din cutie mecanică
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea uleiului din cutie automată
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea uleiului casetei de direcție
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Înlocuirea tosol / antifriz
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Înlocuirea lichidului de frână
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico5} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Motor</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Diagnosticarea si repararea 
  //                         motoarelor pe benzină și diesel
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Înlocuirea curelei de distribuție, 
  //                         a lanțului de transmisie și a elementelor auxiliare
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Revizia motorului cu demontare completă
  //                          și înlocuire a pieselor uzate
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Curățarea injectoarelor, înlocuirea bujiilor 
  //                         și reglarea sistemului de alimentare
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Verificarea și eliminarea scurgerilor de ulei, 
  //                         lichid de răcire și alte lichide
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico6} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Reglarea farurilor</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Reglarea a unghiului de înclinare și a direcție fluxului luminos
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Diagnosticarea si repararea sistemului de iluminat
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Configurarea farurilor LED, xenon și halogen
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Verificarea și înlocuirea lămpilor
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Reglarea farurilor conform standardelor
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico7} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Sistem de frânare</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea lichidului de frână
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea plăcuțelor de frană
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Reparație frână de mână
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea discurilor de frână
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico8} alt="" />
  //                   <div>
  //                     <h2 class="col-head">
  //                       Alinierea roților 3D
  //                     </h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Optimizarea uzurii anvelopelor pentru a prelungi durata de viață a anvelopei
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Îmbunătățirea manevrabilității vehiculului și creșterea stabilității drumului
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico9} alt="" />
  //                   <div>
  //                     <h2 class="col-head">
  //                      Alimentarea și întreținerea condiționerelor
  //                     </h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Diagnosticarea condiționerului
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Reumplerea condiționerului cu freon
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Curățarea și dezinfectarea condiționerului
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Reparația condiționerului
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico10} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Schimbarea filtrelor</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea filtrului de combustibil
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea filtrului de aer
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea filtrului de salon
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea filtrului de ulei
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Schimbarea filtrului cutiei de viteze
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico11} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Vulcaniczarea și balansarea roților</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Balansarea roților
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Shimbarea pneurilor (scaturilor)
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Repararea pneurilor
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //               </div>
  //             )}

  //             <div class="show-more" onClick={() => setShowMore(!showMore)}>
  //               {showMore ? "Ascunde" : "Toate serviciile"}
  //               <img
  //                 src={showMoreImg}
  //                 alt=""
  //                 style={{ rotate: !showMore ? "0deg" : "180deg" }}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  // const ruContent = () => {
  //   return (
  //     <div class="single-service services-container">
  //       <div class="inner-data">
  //         <div class="service-detail">
  //           <div class="col-det">
  //             <p class="headf1" id="productss">Услуги Turbo Wheel</p>
  //             <div class="flex-detail">
  //               <div class="col-one">
  //                 <img src={ico1} alt="" />
  //                 <div>
  //                   <h2 class="col-head">Ремонт ходовой</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Диагностика и устранение
  //                       неисправностей в подвеске
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Замена амортизаторов, рычагов,
  //                       шаровых опор и втулок
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Ремонт и регулировка рулевого
  //                       управления
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Проверка и замена ступичных
  //                       подшипников
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Настройка развал-схождения
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //               <div class="col-one">
  //                 <img src={ico2} alt="" />
  //                 <div>
  //                   <h2 class="col-head">Компьютерная диагностика</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Проверка и чтение ошибок
  //                       электронных блоков управления (ECU)
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Диагностика работы двигателя,
  //                       трансмиссии, ABS и других систем
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Анализ параметров работы авто
  //                       в реальном времени
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Сброс ошибок и адаптация после
  //                       ремонта Регулировка сцепления (МКПП)
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Программирование и настройка
  //                       электроники
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //               <div class="col-one">
  //                 <img src={ico3} alt="" />
  //                 <div>
  //                   <h2 class="col-head">Ремонт электрики</h2>
  //                   <ul class="unlist">
  //                     <li>
  //                       <img src={done} alt="" /> Диагностика и устранение
  //                       неисправностей электропроводки
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Замена генераторов и стартеров
  //                     </li>
  //                     <li>
  //                       <img src={done} alt="" /> Настройка и восстановление
  //                       световых приборов
  //                     </li>

  //                     <li>
  //                       <img src={done} alt="" /> Обслуживание и замена
  //                       аккумуляторов
  //                     </li>

  //                     <li>
  //                       <img src={done} alt="" /> Программирование и адаптация
  //                       блоков управления
  //                     </li>
  //                   </ul>
  //                 </div>
  //               </div>
  //             </div>
  //             {showMore && (
  //               <div class="flex-detail mapedCategories">
  //                 <div class="col-one">
  //                   <img src={ico4} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Масла и жидкости </h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Замена масла в двигателе
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена масла в МКПП
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена масла в АКПП
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Замена жидкости
  //                         гидроусилителя руля
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Замена тосола/антифриз
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Замена тормозной жидкости
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico5} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Двигатель (Мотор)</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Диагностика и ремонт
  //                         бензиновых и дизельных двигателей
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена ремня ГРМ, цепи
  //                         привода и вспомогательных элементов
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Капитальный ремонт двигателя
  //                         с полной разборкой и заменой изношенных деталей
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Очистка форсунок, замена
  //                         свечей зажигания и настройка топливной системы
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Проверка и устранение утечек
  //                         масла, охлаждающей жидкости и других жидкостей
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico6} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Регулировка фар</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Точная настройка угла
  //                         наклона и направления светового потока
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Диагностика и устранение
  //                         неисправностей системы освещения
  //                       </li>

  //                       <li>
  //                         <img src={done} alt="" /> Настройка LED, ксеноновых и
  //                         галогенных фар
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Проверка и замена ламп, при
  //                         необходимости
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Регулировка фар в
  //                         соответствии с стандартами
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico7} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Тормозная система</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Замена тормозной жидкости
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена колодок (мотора)
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Ремонт ручного тормоза
  //                         (ремонт ручника)
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена тормозных дисков
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico8} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Развал-схождение 3D</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Оптимизация износа шин для
  //                         продления их срока службы
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Улучшение управляемости
  //                         автомобиля и повышение устойчивости на дороге
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico9} alt="" />
  //                   <div>
  //                     <h2 class="col-head">
  //                       Заправка и обслуживание кондиционеров
  //                     </h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Диагностика кондиционера
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Заправка кондиционера
  //                         фреоном
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Очистка и дезинфекция
  //                         системы от загрязнений и бактерий
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Ремонт кондиционера
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico10} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Шиномонтаж и балансировка колёс</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" />
  //                         Балансировка колёс
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" />
  //                         Замена шин (переобувка)
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Ремонт шин
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //                 <div class="col-one">
  //                   <img src={ico11} alt="" />
  //                   <div>
  //                     <h2 class="col-head">Фильтра</h2>
  //                     <ul class="unlist">
  //                       <li>
  //                         <img src={done} alt="" /> Замена топливного фильтра
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена воздушного фильтра
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена фильтра салона
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена фильтра масляного
  //                         руля
  //                       </li>
  //                       <li>
  //                         <img src={done} alt="" /> Замена фильтра коробки
  //                         передач
  //                       </li>
  //                     </ul>
  //                   </div>
  //                 </div>
  //               </div>
  //             )}

  //             <div class="show-more" onClick={() => setShowMore(!showMore)}>
  //               {showMore ? "Свернуть" : "Показать"}
  //               <img
  //                 src={showMoreImg}
  //                 alt=""
  //                 style={{ rotate: !showMore ? "0deg" : "180deg" }}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }
  // console.log("lang", lang.lang)
  // const content = lang === "ro" ? roContent() : ruContent()
  //return content
  return <></>
}

export default ShortAdd
